// extracted by mini-css-extract-plugin
export default {"trans_text":"TranscriptText_trans_text__pkj3P","a_text":"TranscriptText_a_text__kCuNd"};